import { render } from "./loadingState.vue?vue&type=template&id=06f5657f&name=loadingState"
import script from "./loadingState.vue?vue&type=script&lang=js"
export * from "./loadingState.vue?vue&type=script&lang=js"

import "./loadingState.vue?vue&type=style&index=0&id=06f5657f&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_im/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__